import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      if (!sessionId) {
        toast.error("Google sign-in was cancelled.");
        navigate("/login");
        return;
      }
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data.user);
        window.history.replaceState({}, "", "/app");
        toast.success("Signed in with Google.");
        navigate(data.user.onboarded ? "/app" : "/onboarding");
      } catch {
        toast.error("Google sign-in failed.");
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="relative z-10 flex min-h-screen items-center justify-center">
      <div className="flex flex-col items-center gap-4 text-white/70">
        <Loader2 className="h-8 w-8 animate-spin text-gold" />
        Signing you in…
      </div>
    </div>
  );
}
